/*
 * @Author: DQL
 * @Date: 2020-03-18 09:56:04
 * @LastEditors: DQL
 * @LastEditTime: 2021-05-01 13:39:18
 * @Description: file content
 */

import axios from 'axios';
import config from '@/config';

const commontCtx = config.commontCtx;
const iffApi = config.ctx.iffApi;

export const deptService = {
  // 获取树
  getTree: (params) => { return axios.get(`${commontCtx}/dept/tree/async`, { params: params }); },

  // 获取
  get: (deptCode) => { return axios.get(`${commontCtx}/dept/v2/${deptCode}`); },

  // 新增
  save: (params) => { return axios.post(`${commontCtx}/dept/save`, params); },

  // 修改
  update: (params) => { return axios.put(`${commontCtx}/dept/update`, params); },

  // 删除
  delete: (deptCode) => { return axios.delete(`${commontCtx}/dept/delete/${deptCode}`); },

  // 获取消防单位列表
  getLwdwList: () => { return axios.get(`${iffApi}/dept/lwdw/list`); },

  // 查询部门关联的消防单位
  getDeptRelatedLwdw: (deptCode) => { return axios.get(`${iffApi}/dept/lwdw/related`, { params: { deptCode } }); },

  // 保存部门与消防单位关联（单个）
  saveLwdwRelation: (deptCode, ssdw) => { return axios.post(`${iffApi}/dept/lwdw/save`, null, { params: { deptCode, ssdw } }); },

  // 批量保存部门与消防单位关联
  batchSaveLwdwRelation: (deptCode, ssdwList) => { return axios.post(`${iffApi}/dept/lwdw/batch/save`, { deptCode, ssdwList }); },

  // 删除部门与消防单位关联
  deleteLwdwRelation: (deptCode, ssdw) => { return axios.post(`${iffApi}/dept/lwdw/delete`, null, { params: { deptCode, ssdw } }); }
};
